import {CordovaService} from "../../Services/CordovaService";
import {StateService} from "angular-ui-router";
import {EExternalProjectType, EKind, EStampType, ITimeEntryTypeVm, ProxyContainer} from '../../Data/Data';
import {TimeQueueItem} from '../../Services/TimeQueueItem';
import {TimeEntryDataService} from '../../Services/TimeEntryDataService';
import {NotificationService} from '../../Services/NotificationService';
import {EntryQueueService} from '../../Services/EntryQueueService';
import {TerminalSessionService} from "../../Services/TerminalSessionService";
import {ConfirmDialog} from "../../Models/confirm-dialog";
import {AuthenticationService} from '../../Services/AuthenticationService';
import {NavigationService} from '../../Services/NavigationService';
import {ScannerService} from '../../Services/ScannerService';


export class TerminalHomeController {
  static controllerId = 'TerminalHomeController';
  static $inject = [
    "$scope",
    "$state",
    "$timeout",
    ScannerService.serviceId,
    '$proxy',
    TimeEntryDataService.serviceId,
    NotificationService.serviceId,
    EntryQueueService.serviceId,
    TerminalSessionService.serviceId,
    AuthenticationService.serviceId,
    NavigationService.serviceId
  ];

  type: ITimeEntryTypeVm;
  confirmDialog = new ConfirmDialog();

  constructor(private $scope: ng.IScope,
              private $state: StateService,
              private $timeout: ng.ITimeoutService,
              private scanService: ScannerService,
              private $proxy: ProxyContainer,
              private timeEntryData: TimeEntryDataService,
              private notification: NotificationService,
              private queue: EntryQueueService,
              private terminalSession: TerminalSessionService,
              private auth: AuthenticationService,
              private nav: NavigationService) {

    this.loadType();
    this.terminalSession.continue();
  }

  async loadType() {
    this.type = await this.timeEntryData.getDefault(EKind.Work);
  }

  get isOnline() {
    return this.auth.serverAvailable;
  }


  get employee() {
    return this.terminalSession.employee;
  }

  get loggedIn() {
    return this.terminalSession.employee !== null &&
      this.terminalSession.employee !== undefined;
  }

  get logoutTime() {
    return this.terminalSession.logoutTime;
  }

  async scanBadge() {
    const result = await this.scanService.scanCode({
      preferFrontCamera: true,
      showFlipCameraButton: false,
      showTorchButton: true,
    });

    if (result.cancelled) {
      return;
    }

    const employeeNumb = parseInt(result.text);

    if (isNaN(employeeNumb)) {
      alert(`Invalid Employee ${result.text}`);
      return;
    }

    this.terminalSession.newSession(employeeNumb);
  }

  extendLogoutTimeout() {
    this.terminalSession.extendLogoutTimeout();
  }

  logout() {
    this.terminalSession.logout();
  }

  canLogoutTablet() {
    return this.terminalSession.employee && this.auth.hasClaimWithUser('logout', this.terminalSession.employee);
  }

  async tabletLogout() {
    try {
      this.terminalSession.logout();
      await this.auth.logout();
      this.nav.goToState('login');
    } finally {
      window.location.reload();
    }
  }

  canEnter() {
    return this.terminalSession.employee && !!this.terminalSession.employee.defaultProject
  }

  enter() {
    this.$state.go('enter', {person: this.employee, confirm: true});
  }

  start() {
    this.$state.go('start', {person: this.employee});
  }

  leave() {
    this.queue.enqueue(new TimeQueueItem(this.type.id, 0, EExternalProjectType.Proj,
      this.employee.id, new Date(), EStampType.Stop));

    this.confirmDialog.open('Buchung gesendet', false, 2000).then(() => {
      this.terminalSession.logout();
    });
  }

  openLastBookings() {
    this.terminalSession.pause();
    this.$state.go('booking-list', {
      userId: this.terminalSession.employee.id
    });
  }
}
